/**
 * Preset source BT + disjoncteur de branchement — cas courant Enedis / BT.
 * Aligné sur RapteckApp/src/components/rapport/presets/standardEnedisBranchement.js
 */

export function buildStandardEnedisSourceBT(localisation) {
  const loc = (localisation || '').trim();
  const nature_designation = 'Disjoncteur Général de Branchement';

  let type_source = 'public';
  if (nature_designation.toLowerCase().includes('réseau interne')) {
    type_source = 'prive';
  } else if (nature_designation.toLowerCase().includes('réseau de distribution public')) {
    type_source = 'public';
  }

  return {
    nature_designation,
    nature_designation_autre: '',
    origine: "Distributeur public d'énergie ENEDIS",
    origine_autre: '',
    localisation: loc,
    type_comptage: 'Comptage à Puissance Limitée',
    type_comptage_autre: '',
    tension: '400',
    puissance: '36',
    puissance_autre: '',
    intensite: '60',
    schema_liaison_terre: 'TT',
    courant_court_circuit: '3',
    courant_court_circuit_autre: '',
    type_source,
  };
}

export function buildStandardEnedisDisjoncteur() {
  return {
    type: 'DD43',
    type_autre: '',
    calibre_reglage: '60',
    calibre_reglage_autre: '',
    im_courbe: 'UG',
    pdc: '6',
    pdc_autre: '',
    section: '4x16 mm²',
    nature: 'Cu',
    coef_global_iz: '0,9',
    coef_global_iz_autre: '',
    idn: '500',
    tempo: 'S',
    essai: 'B',
    isol: '',
    isol_autre: '',
  };
}
